<div class="vh-100 m-3 d-flex w-100 flex-grow-1">
    <div class="d-flex flex-column flex-grow-1">
        <div>
            <span class="fs-4"> {{ "create" | translate }} </span>  
            <hr>
        </div>
        <div class="card" > 
            <div class="card-body">
                <form [formGroup]="productForm">
                    <div class="mb-3">
                        <label for="name" class="form-label">{{ "name" | translate }}</label>
                        <input type="text" class="form-control" id="name" name="name" formControlName="name">
                        @if (productForm.controls?.['name'].invalid && productForm.controls?.['name'].touched) {
                            <div class="invalid-feedback">
                                {{ "required_name" | translate }}
                            </div>
                        }
                    </div>
                    <div class="mb-3">
                        <label for="description" class="form-label">{{ "description" | translate }}</label>
                        <textarea class="form-control" id="description" name="description" formControlName="description"></textarea>
                    </div>
                    <div class="mb-3">
                        <label for="price" class="form-label">{{ "price" | translate }}</label>
                        <input type="number" class="form-control" id="price" name="price" formControlName="price">
                        @if (productForm.controls?.['price'].invalid && productForm.controls?.['price'].touched) {
                            <div class="invalid-feedback">
                                {{ "required_price" | translate }}
                            </div>
                        }
                    </div>
                    <div class="d-flex">
                        <button type="submit" class="btn btn-primary ms-auto me-2" (click)="createProduct()">{{ "save" | translate }}</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">{{ "cancel" | translate }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>